export function targetBlank(url: string): string | undefined {
  const target = url.toLowerCase().includes('lemanapro');
  return target ? undefined : '_blank';
}
